'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useNavContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useNavContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useNavContextValues_unstable(state) {
    const { selectedValue, selectedCategoryValue, onRegister, onUnregister, onSelect, getRegisteredNavItems, onRequestNavCategoryItemToggle, openCategories, multiple, density, onNavItemSelect, tabbable } = state;
    const navContext = _react.useMemo(()=>({
            selectedValue,
            selectedCategoryValue,
            onSelect,
            onRegister,
            onUnregister,
            getRegisteredNavItems,
            onRequestNavCategoryItemToggle,
            openCategories,
            multiple,
            density,
            onNavItemSelect,
            tabbable
        }), [
        selectedValue,
        selectedCategoryValue,
        onSelect,
        onRegister,
        onUnregister,
        getRegisteredNavItems,
        onRequestNavCategoryItemToggle,
        openCategories,
        multiple,
        density,
        onNavItemSelect,
        tabbable
    ]);
    return {
        nav: navContext
    };
}
